import React from "react";
import { connect } from "react-redux";

const Logo = ({ imgSrc }) => {
  return (
    <div className="form_logo">
      <img src={imgSrc} alt="logo" />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    imgSrc: state.app.domain.LogoUrl
  };
};
export default connect(
  mapStateToProps,
  null
)(Logo);
